import Icon from './Icon';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function FixedActionBar() {
  return (
    <div className="action-bar">
      <a href={SUPPORT_PHONE_TEL} className="action-bar__primary">
        <Icon name="phone" size={18} />
        Call {SUPPORT_PHONE_LABEL}
      </a>
      <button type="button" className="action-bar__secondary" onClick={openZohoChat}>
        <Icon name="chat" size={18} />
        Chat Now
      </button>
    </div>
  );
}
